// Fallback prices used when the Stripe pricing API is unreachable.
// These should match the latest known Stripe values.

export interface PlanPricing {
  id: string;
  name: string;
  monthlyPrice: number;
  annualPrice: number | null;
  monthlyEquivalent: number; // For annual: Math.round(annualPrice / 12)
  isAddOn: boolean;
  perUnit?: string; // e.g. "caregiver" for per-seat pricing
}

export const fallbackPrices: Record<string, PlanPricing> = {
  thrivemax: {
    id: 'thrivemax',
    name: 'ThriveMax',
    monthlyPrice: 19,
    annualPrice: 205,
    monthlyEquivalent: 17,
    isAddOn: false,
  },
  thrivefamily: {
    id: 'thrivefamily',
    name: 'ThriveFamily',
    monthlyPrice: 49,
    annualPrice: 529,
    monthlyEquivalent: 44,
    isAddOn: false,
  },
  'thrivefamily-plus': {
    id: 'thrivefamily-plus',
    name: 'ThriveFamily+',
    monthlyPrice: 10,
    annualPrice: null,
    monthlyEquivalent: 10,
    isAddOn: true,
  },
  'thrivecare-addon': {
    id: 'thrivecare-addon',
    name: 'ThriveCare Add-On',
    monthlyPrice: 15,
    annualPrice: null,
    monthlyEquivalent: 15,
    isAddOn: true,
    perUnit: 'caregiver',
  },
};
